import Responsive from '../../utils/Responsive';
import EventBus from '../../utils/EventBus';

export default {
    props: {
        config: {}
    },
    data: function() {
        return {
            position: 0,
            maxVisibleItems: 0,
            slideWidth: 0,
            slideMargin: 0,
            isEnabled: null,
            isTouchDevice: window.Modernizr && window.Modernizr.touch
        }
    },
    computed: {
        hasNext() {
            return this.totalSlides - this.position > this.maxVisibleItems;
        },
        hasPrev() {
            return this.position > 0;
        },
        slideOffset() {
            return {
                transform: 'translateX(' + this.position * (this.slideWidth + this.slideMargin) * -1 + 'px)'
            }
        },
        maxPosition() {
            let maxPosition = this.totalSlides - this.maxVisibleItems;
            return maxPosition > 0 ? maxPosition : 0;
        }
    },
    watch: {
        isEnabled(newValue, oldValue) {
            if(oldValue === true) {
                // reset slider position when disabling slider
                this.position = 0;
                EventBus.$emit('Slider:reset', Object.assign({}, this.config.eventData, {
                    id: this.$el.id
                }));
            }
        }
    },
    methods: {
        nextSlide() {
            let maxPosition = this.maxPostion;
            let newPosition = this.position + 1;

            if(newPosition > maxPosition) {
                newPosition = maxPosition;
            }

            this.position = newPosition;

            EventBus.$emit('Slider:changeSlide', Object.assign({}, this.config.eventData, {
                id: this.$el.id,
                direction: 1,
                position: this.position,
                maxVisibleItems: this.maxVisibleItems,
                totalSlides: this.totalSlides
            }));
        },
        prevSlide() {
            let newPosition = this.position - 1;

            if(newPosition < 0) {
                newPosition = 0;
            }

            this.position = newPosition;

            EventBus.$emit('Slider:changeSlide', Object.assign({}, this.config.eventData, {
                id: this.$el.id,
                direction: -1,
                position: this.position,
                maxVisibleItems: this.maxVisibleItems,
                totalSlides: this.totalSlides
            }));
        },
        calculate() {
            let slideBoundingRect = this.slidesEl[0].getBoundingClientRect();

            this.slideWidth = slideBoundingRect.width;
            this.slideMargin = parseInt(window.getComputedStyle(this.slidesEl[0]).getPropertyValue('margin-right'), 10);

            let sliderPaddingLeft = parseInt(window.getComputedStyle(this.sliderEl).getPropertyValue('padding-left'), 10);
            let sliderPaddingRight = parseInt(window.getComputedStyle(this.sliderEl).getPropertyValue('padding-right'), 10);
            let sliderWidth = this.sliderEl.offsetWidth - sliderPaddingLeft - sliderPaddingRight;

            // Compensate the last item not having a margin by adding the slide margin to the size of the slider
            this.maxVisibleItems = Math.round((sliderWidth + this.slideMargin) / (this.slideWidth + this.slideMargin));

            // Also recalculate the position
            this.position = (this.position > this.maxPosition) ? this.maxPosition : this.position;
        }
    },
    created() {
        this.isEnabled = !this.isTouchDevice || !Responsive.isInsideBreakpoint('xxl');
        EventBus.$on('Responsive:onResize', () => {
            this.calculate();
        });
        EventBus.$on('Responsive:onBreakpointChange', () => {
            this.isEnabled = !this.isTouchDevice || !Responsive.isInsideBreakpoint('xxl');
        });
    },
    mounted() {
        this.sliderEl = this.$refs.items;
        this.slidesEl = this.sliderEl.children;
        this.totalSlides = this.slidesEl.length;
        this.calculate();
        if(typeof window.picturefill === 'function') {
            window.picturefill(this.sliderEl);
        }
        if(window.Modernizr && !window.Modernizr.objectfit) {
            this.$nextTick(async function() {
                const ObjectFit = (await import('../../utils/polyfills/ObjectFit.js')).default;
                ObjectFit.setElementStyles();
            });
        }
    }
}
